import { useCallback, useEffect, useState } from "react";
import { AxiosResponse } from "axios";
import { IDrugOrderPage } from "../drugOrder.interface";
import drugOrderService from "../drugOrderService";
import { IDrugOrderFilter } from "../drugOrderFilter.interface";

const useGetAllByPatientRecordCode = (filters?: IDrugOrderFilter, enabled = true) => {
  const [data, setData] = useState<IDrugOrderPage>();
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>("");

  const callApi = useCallback(() => {
    return drugOrderService.getAllByPatientRecordCode(filters?.patient_code, filters);
  }, [filters]);

  const transformResponse = useCallback((response: AxiosResponse<IDrugOrderPage>) => {
    if (response) {
      setData(response.data);
    }
  }, []);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const response = await callApi();
      transformResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    (async () => {
      try {
        setLoading(true);
        const response = await callApi();
        transformResponse(response);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [enabled]);

  return { data, error, isLoading, refetch };
};

export default useGetAllByPatientRecordCode;
